if($('.id-779').length){
  if($('.top-clanky').length == 0){
    $('<div class="top-clanky"><h2>'+topClankyNadpis+'</h2><ul>'+topClanek1+topClanek2+topClanek3+topClanek4+'</ul></div>').insertBefore('.sectionDescription');
  }
}



function loadDescBlogNew() {

  // 🔒 Zámek proti vícenásobnému spuštění (např. z jiných JS souborů)
  if (window.__descBlogLoaded) return;
  window.__descBlogLoaded = true;

  console.trace('loadDescBlog called');

  var storageKey = 'descBlogCache';
  var $container = $('.blog-items');

  if (!$container.length) return;

  var cached = sessionStorage.getItem(storageKey);

  // =========================
  // 🔹 Pokud existuje cache
  // =========================
  if (cached) {
    $container.empty().html(cached);
    initBlogFeatures($container);
    return;
  }

  // =========================
  // 🔹 Pokud cache neexistuje
  // =========================
  $.ajax({
    url: '/cache/blog/',
    type: 'GET',
    success: function (response) {

      var blogDiv = $('<div>').html(response);

      // první 2 články
      var blogs = blogDiv
        .find('#newsWrapper .news-item')
        .slice(0, 3);

      // odstraníme případný header (pro jistotu)
      blogs.find('.article-header').remove();

      // oprava lazy obrázků
      blogs.find('img').each(function () {
        var dataSrc = $(this).attr('data-src');
        if (dataSrc) $(this).attr('src', dataSrc);
      });

      // uložíme čisté články
      var cleanHtml = $('<div>').append(blogs.clone()).html();
      sessionStorage.setItem(storageKey, cleanHtml);

      $container.empty().html(cleanHtml);

      initBlogFeatures($container);
    }
  });
}


// =======================================
// Inicializace funkcí jen v blog-items
// =======================================
function initBlogFeatures($scope) {
  articleHeader($scope);
  loadArticleHeadersFromApi($scope);
}


// =======================================
// Hlavička článku
// =======================================
function articleHeader($scope) {

  $scope.find('.news-item').each(function () {

    var $item = $(this);

    // vždy nejdřív odstranit starý header
    $item.find('.article-header').remove();

    var timeText = $item.find('time').text();

    const html = `
      <div class="article-header">
        <div class="info">
          <span class="time">${timeText}</span>
          <span class="readtime"></span>
        </div>
        <div class="author"></div>
      </div>
    `;

    $item.find('.image').after(html);
  });
}


// =======================================
// Načtení dat z API
// =======================================
function loadArticleHeadersFromApi($scope) {

  const urls = [];
  const map = {};

  $scope.find('.news-item').each(function () {

    const $item = $(this);
    const $link = $item.find('a').first();
    if (!$link.length) return;

    let href = $link.attr('href');
    if (!href) return;

    if (href.indexOf('http') === 0) {
      try {
        href = new URL(href).pathname;
      } catch (e) {
        return;
      }
    }

    if (!href.endsWith('/')) href += '/';

    urls.push(href);
    map[href] = $item;
  });

  if (!urls.length) return;

  $.ajax({
    url: 'https://web.svihej.cz/api-get-posts.php',
    type: 'POST',
    contentType: 'application/json',
    dataType: 'json',
    data: JSON.stringify({ urls }),

    success: function (response) {

      const apiData = response?.data || [];

      urls.forEach(function (url) {

        const $item = map[url];
        if (!$item) return;

        const $header = $item.find('.article-header');

        const data = apiData.find(function (d) {
          if (!d?.url) return false;
          const path = d.url.endsWith('/') ? d.url : d.url + '/';
          return path === url;
        });

        const readingMinutes = data?.reading_minutes ?? 4;
        const authorName = data?.author_name || 'Marek Vaněček';
        const authorImage = '/user/documents/upload/authorsBlog/' +
             authorNameToFilename(authorName) + '.jpeg';

        $header.find('.readtime')
          .text(readingMinutes + ' min čtení');

        $header.find('.author').html(`
          <img 
            src="${authorImage}" 
            alt="${authorName}"
            data-souce-image="${authorImage}"
            onerror="this.onerror=null;this.src='/user/documents/upload/authorsBlog/attachment2.jpeg';"
          >
          <span>${authorName}</span>
        `);
      });
    }
  });
}


// =======================================
// Helper
// =======================================
function authorNameToFilename(name) {
  if (!name) return '';

  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}


// =======================================
// Spuštění
// =======================================
$(document).ready(function () {
  loadDescBlogNew();
});

if($('.type-posts-listing').length){
  $(document).ready(function () {
  postsListings();
  });

document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    postsListings();
});
  

}

function postsListings(){
  $(function () {

  var $items = $('.news-item');

  if (!$items.length) return;

  $items.each(function () {

    var $item = $(this);

    // pokud už header existuje, přeskočit
    if ($item.find('.article-header').length) return;

    var timeText = $item.find('time').text();

    var html = `
      <div class="article-header">
        <div class="info">
          <span class="time">${timeText}</span>
          <span class="readtime"></span>
        </div>
        <div class="author"></div>
      </div>
    `;

    $item.find('.image').after(html);
  });

});
loadArticleHeadersFromApi($(document));
}